import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue"
import PasswordForm from "@/modules/Users/Invitation/PasswordForm/PasswordForm.vue"
import PersonalInfoForm from "@/modules/Users/Invitation/PersonalInfoForm/PersonalInfoForm.vue"
import { useMutation } from "@/hooks/useMutation"
import { useNotification } from "@/hooks/useNotification"
import {
  UpdateProfileMutation,
  UpdateProfileMutationMutation,
  UpdateProfileMutationMutationVariables,
  UpdatePasswordMutation,
  UpdatePasswordMutationMutation,
  UpdatePasswordMutationMutationVariables,
  UploadFile,
  PhoneInput,
  ClientUserDetailsQuery,
  ClientUserDetailsQueryQueryVariables,
  ClientUserDetailsQueryQuery,
} from "@/gql"
import { useQuery } from "@vue/apollo-composable"
import { useAuth } from "@/store/auth/useAuth"
import { UpdateSessionPayload } from "@/store/auth"

type UserInput = {
  firstName: string
  lastName: string
  email: string
  avatar: UploadFile | null
  phone: PhoneInput
}

type FormInput = {
  newPassword: string
  currentPassword: string
  userInput: UserInput
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountInformationTab',
  setup(__props) {

const { addSuccess } = useNotification()
const { mutate } = useMutation()
const { updateSession } = useAuth()

const form = ref<FormInput>({
  newPassword: "",
  currentPassword: "",
  userInput: {
    firstName: "",
    lastName: "",
    email: "",
    avatar: null,
    phone: {
      countryCode: "",
      number: "",
    },
  },
})

const { loading, onResult } = useQuery<
  ClientUserDetailsQueryQuery,
  ClientUserDetailsQueryQueryVariables
>(ClientUserDetailsQuery)

onResult((result) => {
  if (result?.data?.meUser) {
    form.value.userInput = {
      firstName: result.data.meUser.firstName,
      lastName: result.data.meUser.lastName,
      email: result.data.meUser.email,
      avatar: result.data.meUser.avatar || null,
      phone: {
        countryCode: result.data.meUser.phoneCountryCode || "",
        number: result.data.meUser.phoneNumber || "",
      },
    }
  }
})

const isUserInfoSubmitting = ref(false)
const isPasswordSubmitting = ref(false)

const onSubmitUserInformation = async () => {
  const payload: any = {
    firstName: form.value.userInput.firstName,
    lastName: form.value.userInput.lastName,
    email: form.value.userInput.email,
    avatar: null,
    phone: form.value.userInput.phone,
  }

  if (!form.value.userInput.avatar?.id) {
    payload.avatar = form.value.userInput.avatar
  }

  isUserInfoSubmitting.value = true
  const result = await mutate<
    UpdateProfileMutationMutation,
    UpdateProfileMutationMutationVariables
  >({
    mutation: UpdateProfileMutation,
    variables: {
      ...payload,
    },
    handlePayloadErrors: true,
  })
  if (result?.data?.updateProfile?.profile?.id) {
    addSuccess("Profile updated successfully!")

    updateSession({ ...result.data.updateProfile.profile } as unknown as UpdateSessionPayload)
  }
  isUserInfoSubmitting.value = false
}

const onChange = (value: typeof form.value.userInput) => {
  form.value = {
    ...form.value,
    userInput: {
      ...form.value.userInput,
      ...value,
    },
  }
}

const onConfirmPassword = async () => {
  isPasswordSubmitting.value = true

  const result = await mutate<
    UpdatePasswordMutationMutation,
    UpdatePasswordMutationMutationVariables
  >({
    mutation: UpdatePasswordMutation,
    variables: {
      newPassword: form.value.newPassword,
      currentPassword: form.value.currentPassword,
    },
  })

  if (result?.data?.updatePassword) {
    addSuccess("Password updated successfully!")
  }
  isPasswordSubmitting.value = false
}

return { __sfc: true,addSuccess, mutate, updateSession, form, loading, onResult, isUserInfoSubmitting, isPasswordSubmitting, onSubmitUserInformation, onChange, onConfirmPassword, PasswordForm, PersonalInfoForm }
}

})